import { useCallback, useRef, useState } from 'react';

/**
 * Prevents duplicate submissions. `run(fn)` ignores calls made while a previous one is still
 * running (a ref is used because state updates are asynchronous and a fast double click is not).
 * Returns [submitting, run]. `run` resolves to fn's result, or undefined when it was ignored.
 */
export function useSubmitGuard() {
  const [submitting, setSubmitting] = useState(false);
  const busy = useRef(false);

  const run = useCallback(async (fn) => {
    if (busy.current) return undefined;
    busy.current = true;
    setSubmitting(true);
    try {
      return await fn();
    } finally {
      busy.current = false;
      setSubmitting(false);
    }
  }, []);

  return [submitting, run];
}
